class ChangePasswordBuilder {
  setCurrentPassword(currentPassword) {
    this.currentPassword = currentPassword;
    return this;
  }
  setPassword(password) {
    this.password = password;
    return this;
  }
  setConfirmPassword(confirmPassword) {
    this.confirmPassword = confirmPassword;
    return this;
  }
  build() {
    return {
      currentPassword: this.currentPassword,
      password: this.password,
      confirmPassword: this.confirmPassword,
    };
  }
}

export default ChangePasswordBuilder;
